import type { FC } from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';
import { SparkleIcon } from '@phosphor-icons/react/dist/csr/Sparkle';
import styles from './agentHistory.module.scss';
import { useAgentChatUi } from "@/context/agent/useAgentChatUi.ts";

const AgentToggle: FC = () => {
  const { t } = useTranslation('translation', { keyPrefix: 'agentHistory' });
  const { isOpen, toggle } = useAgentChatUi();

  return (
    <div
      data-testid="agent-history-dropdown"
      className={cn(styles.agentHistoryWrapper, { [styles.agentHistoryWrapperActive]: isOpen })}
    >
      <div className={styles.agentHistoryIcon} tabIndex={0} role="button" aria-label={t('title')} onClick={toggle}>
        <SparkleIcon size={24} />
      </div>
    </div>
  );
};

export default AgentToggle;
